/**
 * 消息相关路由配置
 */
const newsRoutes = [
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news/NewsView.vue'),
    meta: {
      title: '消息',
      requireAuth: false,
      hideNav: true
    }
  }
]

export default newsRoutes
